<template>
  <div class="page">
    <div class="container">
      <h1>Web Development</h1>
      <div class="service-content">
        <div class="service-intro">
          <p>We create modern, responsive websites that deliver exceptional user experiences.</p>
        </div>
        <div class="features">
          <div class="feature">
            <h3>Frontend Development</h3>
            <p>Vue.js, React, Angular applications with modern JavaScript</p>
          </div>
          <div class="feature">
            <h3>Backend Development</h3>
            <p>Node.js, Python, PHP APIs and server-side solutions</p>
          </div>
          <div class="feature">
            <h3>Full-Stack Solutions</h3>
            <p>Complete web applications from database to deployment</p>
          </div>
          <div class="feature">
            <h3>E-commerce</h3>
            <p>Online stores with payment integration and inventory management</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.page {
  padding: 2rem;
  height: 100%;
  background: #f5f5f5;
  color: #333;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-align: center;
}

.service-intro {
  text-align: center;
  margin-bottom: 3rem;
}

.service-intro p {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.feature {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  text-align: center;
}

.feature h3 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: #2c3e50;
}

.feature p {
  font-size: 1.1rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .page {
    padding: 1rem;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  .features {
    grid-template-columns: 1fr;
  }
}
</style>